import {
  PLANS_CATALOG,
  OVERAGE_RATE_CENTS_PER_RENDER,
} from "../../../src/shared/plans-catalog";

export interface PlanConfig {
  name: string;
  tier: string;
  monthlyPrice: number | null; // null = no displayed price (Enterprise)
  annualPrice: number | null;
  rendersPerMonth: string;
  maxConcurrent: string;
  retention: string;
  features: string[];
  cta: string;
  startingAt?: boolean;
}

function fmtRetention(ms: number): string {
  const hours = ms / (60 * 60 * 1000);
  return `${hours} hours`;
}

export const PLANS: PlanConfig[] = PLANS_CATALOG.map((p) => ({
  name: p.name,
  tier: p.slug,
  monthlyPrice: p.monthlyPriceCents === null ? null : p.monthlyPriceCents / 100,
  annualPrice: p.annualPriceCents === null ? null : p.annualPriceCents / 100,
  rendersPerMonth: p.isEnterprise
    ? "100,000+"
    : p.rendersPerMonth.toLocaleString(),
  maxConcurrent: p.isEnterprise ? "50+" : String(p.maxConcurrent),
  retention: fmtRetention(p.retentionMs),
  features: [...p.features],
  cta: p.isFree ? "Current Plan" : p.isEnterprise ? "Contact Sales" : "Upgrade",
  startingAt: p.isEnterprise ?? false,
}));

/**
 * Non-throwing features lookup over the dashboard's local PLANS.
 *
 * CHK-39: checkout's plans API no longer returns `features`; the UI renders
 * feature bullets exclusively from this local source. Unlike the shared
 * catalog's `getCatalogEntry()` (which throws on unknown slugs), this returns
 * `[]` for any slug the local catalog doesn't carry — checkout legitimately
 * permits slugs (e.g. "business") that pdfglyph doesn't sell.
 */
export function planFeatures(slug: string): string[] {
  return PLANS.find((p) => p.tier === slug)?.features ?? [];
}

export { OVERAGE_RATE_CENTS_PER_RENDER };
